<template>
  <div style="height: 100%">
    <web-list v-if="currentView==='webList'"></web-list>
    <access-code v-else-if="currentView==='accessCode'"></access-code>
    <add-web v-else-if="currentView==='addWeb'"></add-web>
  </div>
</template>
<script>
import WebList from './webList'
import AddWeb from './addWeb'
import AccessCode from './accessCode'

export default {
  name: '',
  data() {
    return {
      currentView: 'webList', // 当前激活的页面:webList/accessCode/addWeb三选一
      currentChannelInfoId: '', // 当前选中的配置项(编辑)
      accessScriptSrc: '' // 接入代码src
    }
  },
  components: {
    WebList,
    AddWeb,
    AccessCode
  },
  methods: {
    changeView(view) {
      this.currentView = view
    }
  }
}
</script>
